/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Transcript_Export_Preset_Save_FailedInputs */

const en_transcript_export_preset_save_failed = /** @type {(inputs: Transcript_Export_Preset_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to save preset: ${i?.error}`)
};

const fr_transcript_export_preset_save_failed = /** @type {(inputs: Transcript_Export_Preset_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de l'enregistrement du prereglage : ${i?.error}`)
};

const de_transcript_export_preset_save_failed = /** @type {(inputs: Transcript_Export_Preset_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voreinstellung konnte nicht gespeichert werden: ${i?.error}`)
};

const it_transcript_export_preset_save_failed = /** @type {(inputs: Transcript_Export_Preset_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile salvare il preset: ${i?.error}`)
};

const ru_transcript_export_preset_save_failed = /** @type {(inputs: Transcript_Export_Preset_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось сохранить предустановку: ${i?.error}`)
};

const es_transcript_export_preset_save_failed = /** @type {(inputs: Transcript_Export_Preset_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo guardar el ajuste preestablecido: ${i?.error}`)
};

const zh_cn2_transcript_export_preset_save_failed = /** @type {(inputs: Transcript_Export_Preset_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`保存预设失败：${i?.error}`)
};

const ja_transcript_export_preset_save_failed = /** @type {(inputs: Transcript_Export_Preset_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プリセットの保存に失敗しました: ${i?.error}`)
};

const hi_transcript_export_preset_save_failed = /** @type {(inputs: Transcript_Export_Preset_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रीसेट सहेजने में विफल: ${i?.error}`)
};

const pt_pt2_transcript_export_preset_save_failed = /** @type {(inputs: Transcript_Export_Preset_Save_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao salvar a predefinição: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to save preset: {error}" |
*
* @param {Transcript_Export_Preset_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_preset_save_failed = /** @type {((inputs: Transcript_Export_Preset_Save_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Preset_Save_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_preset_save_failed(inputs)
	if (locale === "de") return de_transcript_export_preset_save_failed(inputs)
	if (locale === "it") return it_transcript_export_preset_save_failed(inputs)
	if (locale === "ru") return ru_transcript_export_preset_save_failed(inputs)
	if (locale === "es") return es_transcript_export_preset_save_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_preset_save_failed(inputs)
	if (locale === "ja") return ja_transcript_export_preset_save_failed(inputs)
	if (locale === "hi") return hi_transcript_export_preset_save_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_preset_save_failed(inputs)
	return en_transcript_export_preset_save_failed(inputs)
});